import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const StyledThrobber = styled(Throbber)`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(0,0,0,0.1);
`;

export const ContactPerson = styled.div`
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 16px;
    }
`;
